import React, {useEffect, useState, useContext} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {
    FormControl,
    Grid,
    LinearProgress,
    IconButton,
    Paper,
    Typography, TextField
} from "@material-ui/core";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RefreshIcon from '@material-ui/icons/Refresh';
import axios from "axios";
import qs from "qs";
import {useHistory} from "react-router-dom";
import {authUser} from "../funciones/AuthUser";
import {AuthContext} from "../context/AuthContext";
import {GeneralesContext} from '../context/GeneralesContext'

import TablaRefacciones from "./TablaRefacciones";
import CrearRefacciones from "./CrearRefacciones";
import {ToastContainer} from "react-toastify";
import {ErrorGeneral, llamadaApiToken} from "../funciones/ClienteAxios";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "block",
        width: '750px',
        textAlign: 'center',
        color: theme.palette.primary.main
    },
    botones: {
        margin: theme.spacing(1),
    }, formStyle: {
        marginBottom: 35
    }
}));

export default function Refacciones() {

    const classes = useStyles();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const history = useHistory();

    const [listaRefacciones, setListaRefacciones] = useState([]);

    const [modalAgregarAbierto, setModalAgregarAbierto] = useState(false);
    const [modalTitulo, setModalTitulo] = useState("");
    const [actualiza, setActualiza] = useState(false);

    const {usuario, guardarUsuario} = useContext(AuthContext);
    const {guardarGenerales} = useContext(GeneralesContext);

    const [ordenBusq, setOrdenBusq] = useState({refaccionId: ''});
    const {refaccionId} = ordenBusq;

    let nvlSNPermiso = '5';

    useEffect(() => {

        const getRefacciones = () => {
            let data = qs.stringify({
                idDispositivo: "987yugbhcdsscs",
            });
            let url = "/refaccion-list";

            function respuestaRefacciones(auxiliar) {
                if (auxiliar[0].Id !== -1) {
                    setListaRefacciones(auxiliar);
                }
            }

            llamadaApiToken(data, url, respuestaRefacciones, ErrorGeneral, history, source)
        };

        const autenticado = authUser();
        if (!autenticado) {
            localStorage.clear();
            history.push('/');
            guardarUsuario([]);
        } else {
            const usu = localStorage.getItem('UsuarioNom');
            const nvl = localStorage.getItem('Tipo');
            guardarUsuario({Nombre: usu, nivel: nvl});
            guardarGenerales({Titulo: 'Catálogo Refacciones'})
            getRefacciones();
        }
    }, [actualiza]);

    const modalAgregar = modalAgregarAbierto ? (usuario?.nivel !== undefined && usuario.nivel !== nvlSNPermiso ?
        <CrearRefacciones modalAbierto={modalAgregarAbierto}
                          setModalAbierto={setModalAgregarAbierto}
                          titulo={modalTitulo}
                          listaRefacciones={listaRefacciones}
        /> : null) : null;


    function refreshData() {
        setListaRefacciones([]);
        setActualiza(!actualiza)
    }

    function abrirModal() {
        setModalTitulo("Nueva Refacción");
        setModalAgregarAbierto(!modalAgregarAbierto);
    }

    const handleSearch = (e) => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            setOrdenBusq({
                ...ordenBusq,
                [e.target.name]: e.target.value.trim()
            })
        }
    }

    const visualizartabla = listaRefacciones.length > 0 ?

        <TablaRefacciones listaRefacciones={listaRefacciones}
                          usuarioContext={usuario}
                          actualiza={actualiza}
                          setActualiza={setActualiza}
                          refaccionId={refaccionId}
        />
        :
        <Paper className={classes.root}>
            <Typography>
                Cargando...
                <LinearProgress/>
            </Typography>
        </Paper>

    return (<>
        <Grid container>
            <Grid item className={classes.formStyle}>
                <FormControl className={classes.botones} style={{marginLeft: 1 + 'rem'}}>
                    <IconButton onClick={refreshData} size={'small'}>
                        <RefreshIcon color="primary"/>
                    </IconButton>
                </FormControl>
                {usuario.nivel !== undefined && usuario.nivel !== nvlSNPermiso ?
                    <FormControl className={classes.botones} style={{marginLeft: 1 + 'rem'}}>
                        <IconButton onClick={abrirModal} size={'small'}>
                            <AddCircleOutlineIcon color="primary"/>
                        </IconButton>
                    </FormControl> : null}
                <TextField id="outlined-basic" label="Refacción" variant="outlined"
                           size="small" style={{marginLeft: 1 + 'rem'}}
                           name="refaccionId"
                           onChange={handleSearch}
                />
                {visualizartabla}
            </Grid>
        </Grid>
        {modalAgregar}
        <ToastContainer/>
    </>);
}